export const handleServerError = function (err, redirectToErrorPage = false) {
    if (redirectToErrorPage) {
        this.setState({ errorRedirect: true })
    } else {
        this.setState({ errorMessage: true })
    }
}
